import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "description" }
const _hoisted_2 = { class: "form-wrapper" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "input-wr" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "input-row" }
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "input-wr" }
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = {
  key: 0,
  class: "default-error error-box--end-date"
}
const _hoisted_12 = {
  key: 0,
  class: "error-block"
}
const _hoisted_13 = { class: "input-row" }
const _hoisted_14 = { class: "input-wr" }
const _hoisted_15 = {
  key: 0,
  class: "input-prefix"
}
const _hoisted_16 = { class: "input-wr" }
const _hoisted_17 = {
  key: 0,
  class: "input-prefix"
}
const _hoisted_18 = { class: "input-row" }
const _hoisted_19 = { class: "input-wr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    classes: "without-padding height-limited"
  }, {
    content: _withCtx(() => [
      _createVNode($setup["FormModalLayout"], {
        title: "Create Option",
        onBack: _cache[10] || (_cache[10] = ($event: any) => ($setup.close(false)))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            class: "button modal cancel",
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.close(false)))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button modal primary release",
            onClick: $setup.save
          }, "Save")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, "You are creating an option.  " + _toDisplayString($setup.plural($setup.idLotsList.length, "This")) + " " + _toDisplayString($setup.plural($setup.idLotsList.length, "lot", false)) + " will be marked as 'Sold' and no new buyers will be able to submit a Contract information form on " + _toDisplayString($setup.plural($setup.idLotsList.length, "this")) + " " + _toDisplayString($setup.plural($setup.idLotsList.length, "lot", false)) + ".", 1),
          _createElementVNode("form", {
            class: "default-form option-form",
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Option Type", -1)),
                  _createVNode($setup["DropDown"], null, {
                    control: _withCtx(() => [
                      _createElementVNode("button", {
                        class: _normalizeClass(["input dropdown-input", [{ error: $setup.v$.type.$error }, { 'text-muted': !$setup.selectedType.value }]])
                      }, _toDisplayString($setup.selectedType.label), 3)
                    ]),
                    dropdown: _withCtx(() => [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.types, (item, ind) => {
                          return (_openBlock(), _createElementBlock("li", {
                            onClick: ($event: any) => ($setup.form.type = item.value)
                          }, _toDisplayString(item.label), 9, _hoisted_5))
                        }), 256))
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: _normalizeClass(["default-error", { 'hidden-block': !$setup.v$.type.$errors[0]?.$message }])
                  }, _toDisplayString($setup.v$.type.$errors[0]?.$message), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Option Holder", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "holder",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.holder) = $event)),
                    type: "text",
                    placeholder: "Option Holder",
                    class: _normalizeClass({ 'input--error': $setup.v$.holder.$error }),
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.v$.holder.$touch && $setup.v$.holder.$touch(...args)))
                  }, null, 34), [
                    [
                      _vModelText,
                      $setup.form.holder,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["default-error", { 'hidden-block': !$setup.v$.holder.$errors[0]?.$message }])
                  }, _toDisplayString($setup.v$.holder.$errors[0]?.$message), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Option Start Date", -1)),
                  _createVNode($setup["DatePicker"], {
                    modelValue: $setup.form.startDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.startDate) = $event)),
                    "class-field": { 'input--error': $setup.v$.startDate.$error },
                    disabled: false
                  }, null, 8, ["modelValue", "class-field"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["default-error", { 'hidden-block': !$setup.v$.startDate.$errors[0]?.$message }])
                  }, _toDisplayString($setup.v$.startDate.$errors[0]?.$message), 3)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "Option End Date", -1)),
                  _createVNode($setup["DatePicker"], {
                    modelValue: $setup.form.endDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.endDate) = $event)),
                    "class-field": { 'input--error': $setup.v$.endDate.$error },
                    disabled: $setup.regDate
                  }, null, 8, ["modelValue", "class-field", "disabled"]),
                  _createVNode($setup["CheckboxInput"], {
                    class: "end-date--check",
                    label: "Same as Registration date",
                    modelValue: $setup.regDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.check($event)))
                  }, null, 8, ["modelValue"]),
                  ($setup.v$.endDate.required.$invalid)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.v$.endDate.required.$message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              ($setup.v$.endDate.valid.$invalid)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Pay attention that ", -1),
                    _createElementVNode("span", { class: "bold" }, "Option End Date ", -1),
                    _createTextVNode("is earlier than ", -1),
                    _createElementVNode("span", { class: "bold" }, "Option Start Date", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "Land Price", -1)),
                  _createVNode($setup["Cleave"], {
                    id: "price",
                    modelValue: $setup.form.price,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.price) = $event)),
                    modelModifiers: { trim: true },
                    type: "text",
                    placeholder: "Land Price",
                    class: _normalizeClass([{ 'input--error': $setup.v$.price.$error }, { 'p-left': $setup.form.price }]),
                    onBlur: $setup.v$.price.$touch,
                    options: $setup.optionPrice
                  }, null, 8, ["modelValue", "class", "onBlur"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["default-error", { 'hidden-block': !$setup.v$.price.$errors[0]?.$message }])
                  }, _toDisplayString($setup.v$.price.$errors[0]?.$message), 3),
                  ($setup.form.price)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "$"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label" }, "Option Fee", -1)),
                  _createVNode($setup["Cleave"], {
                    id: "fee",
                    modelValue: $setup.form.fee,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.fee) = $event)),
                    modelModifiers: { trim: true },
                    type: "text",
                    placeholder: "Option Fee",
                    class: _normalizeClass([{ 'input--error': $setup.v$.fee.$error }, { 'p-left': $setup.form.fee }]),
                    onBlur: $setup.v$.fee.$touch,
                    options: $setup.optionPrice
                  }, null, 8, ["modelValue", "class", "onBlur"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["default-error", { 'hidden-block': !$setup.v$.fee.$errors[0]?.$message }])
                  }, _toDisplayString($setup.v$.fee.$errors[0]?.$message), 3),
                  ($setup.form.fee)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "$"))
                    : _createCommentVNode("", true),
                  ($setup.form.fee && $setup.form.price)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "input-indent",
                        style: _normalizeStyle($setup.inputIndent)
                      }, "(" + _toDisplayString($setup.persent) + "%)", 5))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, "Conditions", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "condition",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.conditions) = $event)),
                    placeholder: "No conditions"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.form.conditions,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ])
            ])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["isOpen"]))
}